import { getNonce } from 'utils/getNonce'

declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Window {
    __webpack_nonce__: string
  }
}

// NOTE: setting nonce for a sub dependency for radix/dropdown-menu that is not compatible with CSP settings.
window.__webpack_nonce__ = getNonce()
